<!--Mobile Nav-->
<fgb-page-header [pageTitle]="'hawks.bucks.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<!--Sub Nav-->
<div class="container">
  <fgb-arena-cash-nav></fgb-arena-cash-nav>
</div>

<div class="container">
  <h5 class="text-white">{{ 'transfer.credit.title' | translate }}</h5>
  <div
    class="text-white d-flex align-items-center font-weight-bold font-size-14 transfer-credit-description"
    [innerHTML]="'transfer.credit.description' | translate | markdownTranslate"
  ></div>

  <div class="arena-cash-box bg-secondary border border-grey rounded">
    <fgb-transfer-arena-cash></fgb-transfer-arena-cash>
  </div>

  <fgb-transaction-history
    [transactionTypes]="[transactionTypes.ecash, transactionTypes.payment]"
    [ecashView]="true"
    [isTransferPage]="true"
  ></fgb-transaction-history>
</div>
